import { mainPath } from "../../lib/mainPath"
import { requestsTemplates } from "../../lib/requestsTemplates"

export const post = (holidayDateObj) => requestsTemplates.post(mainPath, "/bank_holidays", holidayDateObj)
